<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<a id="cover"></a><div class="cover_image"><div class="image"><img alt="e9780806537191_cover.jpg" src="e9780806537191_cover.jpg"/></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780806537191_cov01.vue?e9dfa73c